import type { Router } from "@/typeDefinitions/custom/Router";
import { SQDCEventActionTypeInternalType, SQDCEventActionTypePreset } from "@/graphql";

const router: Router.LicensedRouterExportType = [
  {
    path: "/idea/settingsOverview",
    name: "SettingsOverview",
    component: () => import("./views/IdeaSiteList.vue"),
    meta: {
      rights: ["idea.admin"],
    },
  },
  {
    path: "/idea/configOverview",
    name: "IdeaConfigOverview",
    component: () =>
      import("@/modules/sqdc/components/eventActionConfig/SQDCEventActionTypeConfigOverview.vue"),
    meta: {
      rights: ["idea.admin"],
    },
    props: {
      internalType: SQDCEventActionTypeInternalType.Idea,
      presets: [SQDCEventActionTypePreset.Idea],
      titleKey: "router.IdeaConfigOverview",
    },
  },
  {
    path: "/idea/config/:siteId/:new?",
    name: "HLPConfig",
    component: () => import("./views/IdeaConfig.vue"),
    meta: {
      rights: ["idea.admin"],
    },
    props: (route) => {
      return {
        siteId: Number(route.params.siteId),
        create: route.params.new === "true",
      };
    },
  },
  {
    path: "/idea/categoryList",
    name: "HLPCategoryList",
    component: () => import("./views/IdeaCategoryList.vue"),
    meta: {
      rights: ["idea.admin"],
    },
  },
  {
    path: "/idea/category/:id",
    name: "HLPCategory",
    component: () => import("./views/IdeaCategory.vue"),
    meta: {
      rights: ["idea.admin"],
    },
    props: (route) => {
      const newMode = route.params.id.toString() === "new";
      return {
        id: newMode ? undefined : parseInt(route.params.id.toString(), 10),
        newMode,
      };
    },
  },
];

export default router;
